<template>
    <div class="container">
        <div class="header_count">
            <div>
                <img src="../../assets/icon/pangao_user_user_bg.png" alt="" />
                <div class="count_title">用户数</div>
                <div class="count_num">{{ userCount }}</div>
            </div>
            <div>
                <img src="../../assets/icon/pangao_user_equipment_bg.png" alt="" />
                <div class="count_title">设备</div>
                <div class="count_num">{{ deviceCount }}</div>
            </div>
            <div>
                <img src="../../assets/icon/pangao_user_active_bg.png" alt="" />
                <div class="count_title">活跃用户</div>
                <div class="count_num">{{ dau }}</div>
            </div>
            <div>
                <img src="../../assets/icon/pangao_user_add_bg.png" alt="" />
                <div class="count_title">本月新增用户</div>
                <div class="count_num">{{ mnu }}</div>
            </div>
        </div>
        <div class="content">
            <div class="conList_title">
                <div class="width_100"></div>
                <div class="width_120">用户ID</div>
                <div>账号</div>
                <div>昵称</div>
                <div>注册时间</div>
                <div class="item_device">设备</div>
                <div class="operation"></div>
                <!-- <div class="exportData">
                    <img src="../../assets/icon/pangao_user_export_button_ic.png" alt="" />
                    导出数据
                </div> -->
            </div>
            <div class="conList_items" v-for="item in list" :key="item.id">
                <div class="width_100">
                    <img :src="item.avatarUrl || defaultAvatar" alt="" />
                </div>
                <div class="width_120">{{ item.id }}</div>
                <div>{{ item.phoneNumber }}</div>
                <div>{{ item.nickname }}</div>
                <div>{{ formatDate(item.createdAt, "y/M/d h:m") }}</div>
                <div class="item_device">{{ item.device }}</div>
                <div class="operation" @click="toDetail(item)">
                    <a>查看</a>
                </div>
            </div>
            <comPage class="comPage" :totalPage="totalPage" :currentPage="currentPage" @currentChange="currentChange"></comPage>
        </div>
    </div>
</template>
<script>
import comSelect from "../../components/comSelect";
import comPage from "../../components/comPage";
import defaultAvatar from "../../assets/icon/avatar.jpg";
import { getAppUserList, getSystemInfo } from "../../http/userPage";
export default {
    components: {
        comSelect,
        comPage,
    },
    data() {
        return {
            defaultAvatar: defaultAvatar,
            userCount: 0,
            deviceCount: 0,
            dau: 0,
            mnu: 0,
            list: [],
            totalPage: 1,
            currentPage: 1,
            searchInput: "",
            searchParam: "",
            currentOptionItem: "",
            options: [{ name: "全部", value: "" }],
        };
    },
    methods: {
        getList() {
            if (this.currentPage) {
                let httpData = {
                    pageId: this.currentPage - 1,
                    pageSize: 10,
                };
                getAppUserList(httpData)
                    .then((res) => {
                        // console.log(res);
                        if (res.data.errCode === 0) {
                            this.list = res.data.result.content;
                            this.totalPage = res.data.result.totalPages;
                            this.list.forEach((item) => {
                                if (!item.devices) {
                                    item.device = "未绑定设备";
                                } else {
                                    item.devices = JSON.parse(item.devices);
                                    if (!item.devices.length) {
                                        item.device = "未绑定设备";
                                    } else {
                                        item.device = `Mac:${item.devices[0].uuid}`;
                                    }
                                }
                            });
                            // console.log(this.list);
                        }
                    })
                    .catch((e) => {
                        console.log(e);
                    });
            }
        },
        getSystemInfo() {
            if (this.currentPage) {
                getSystemInfo()
                    .then((res) => {
                        // console.log(res);
                        if (res.data.errCode === 0) {
                            let data = res.data.result;
                            // console.log(data);
                            this.userCount = data.userCount;
                            this.deviceCount = data.deviceCount;
                            this.dau = data.dau;
                            this.mnu = data.mnu;
                        }
                    })
                    .catch((e) => {
                        console.log(e);
                    });
            }
        },
        addItem() {
            this.$router.push({ name: "" });
        },
        deleteItem(item) {
            layer.confirm("确定删除?", { title: "提示" }, (index1) => {
                layer.confirm("删除之后不可恢复，是否继续?", { title: "提示" }, (index2) => {
                    deleteFunction({
                        id: item.id,
                    }).then((res) => {
                        if (res.data.status == 1) {
                            this.getList();
                            layer.msg("删除成功");
                        }
                    });
                    layer.close(index2);
                });
                layer.close(index1);
            });
        },
        clickOptionItem(item) {
            if (this.currentOptionItem == item.value) {
                return;
            }
            this.currentOptionItem = item.value;
            let query = { ...this.$route.query };
            if (this.currentPage > 1) {
                this.currentPage = 1;
                query.currentPage = 1;
            }
            query.currentOptionItem = this.currentOptionItem;
            this.$router.replace({ query: query });
            this.getList();
        },
        currentChange(val) {
            if (this.currentPage == val) {
                return;
            }
            this.currentPage = val;
            let query = { ...this.$route.query };
            query.currentPage = this.currentPage;
            this.$router.replace({ query: query });
            this.getList();
        },
        searchInputSubmit() {
            if (this.searchInput) {
                this.searchParam = this.searchInput;
                let query = { ...this.$route.query };
                if (this.currentPage > 1) {
                    this.currentPage = 1;
                    query.currentPage = 1;
                }
                this.$router.replace({ query: query });
                this.getList();
            }
        },
        toDetail(item) {
            this.$router.push({ name: "userDetail", query: item });
        },
        // getDeviceMac(str) {
        //     if (!str) {
        //         return "未绑定设备";
        //     }
        //     let devices = JSON.parse(str);
        //     if (!devices.length) {
        //         return "未绑定设备";
        //     }
        //     return `Mac:${devices[0].uuid}`;
        // },
    },
    watch: {
        searchInput(val) {
            if (val == "") {
                this.searchParam = this.searchInput;
                let query = { ...this.$route.query };
                if (this.currentPage > 1) {
                    this.currentPage = 1;
                    query.currentPage = 1;
                }
                this.$router.replace({ query: query });
                this.getList();
            }
        },
    },
    created() {
        this.currentPage = this.$route.query.currentPage || 1;
        this.currentOptionItem = this.$route.query.currentOptionItem || "";
        this.getList();
        this.getSystemInfo();
    },
};
</script>
<style lang="scss" scoped>
.header_count {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-left: -0.5%;
    margin-right: -0.5%;
    & > div {
        position: relative;
        img {
            width: 100%;
            // max-width: 355px;
        }
        .count_title {
            position: absolute;
            top: 20%;
            left: 10%;
            color: #fff;
            font-size: 20px;
        }
        .count_num {
            position: absolute;
            top: 50%;
            left: 10%;
            color: #fff;
            font-size: 40px;
        }
    }
}
.content {
    width: 100%;
    min-height: 626px;
    padding-bottom: 76px;
    position: relative;
    .comPage {
        position: absolute;
        left: 0;
        bottom: 0;
    }
}
.width_100 {
    flex: 0 0 100px;
}
.width_120 {
    flex: 0 0 120px;
}
.conList_items {
    div {
        img {
            width: 40px;
            height: 40px;
            border-radius: 50%;
        }
    }
}
.item_device {
    min-width: 150px;
}
.exportData {
    flex: 0 0 130px;
    border-left: 5px solid #fff;
    background: #ff8914;
    color: #fff;
    cursor: pointer;
    img {
        margin-right: 4px;
    }
}
.operation {
    cursor: pointer;
    &:hover {
        a {
            transform: scale(1.15);
            text-decoration: underline;
        }
    }
}
@media only screen and (max-width: 1500px) {
    .header_count {
        & > div {
            .count_title {
                font-size: 16px;
            }
            .count_num {
                font-size: 32px;
            }
        }
    }
}
@media only screen and (max-width: 1400px) {
    .header_count {
        & > div {
            .count_title {
                top: 16%;
            }
            .count_num {
                font-size: 30px;
            }
        }
    }
}
</style>
